import { render, staticRenderFns } from "./main-dashboard-report.vue?vue&type=template&id=d0da31e2&scoped=true&"
import script from "./main-dashboard-report.vue?vue&type=script&lang=js&"
export * from "./main-dashboard-report.vue?vue&type=script&lang=js&"
import style0 from "./main-dashboard-report.vue?vue&type=style&index=0&id=d0da31e2&lang=scss&scoped=true&"
import style1 from "./main-dashboard-report.vue?vue&type=style&index=1&id=d0da31e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0da31e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardTitle,VCol,VIcon,VRow,VSimpleTable,VSkeletonLoader,VSnackbar,VTooltip})
